import type { CSSProperties } from 'react';
import { toast } from 'sonner';

export const TOAST_CONFIRM_DURATION_MS = 4000;
export const TOAST_ERROR_DURATION_MS = 8000;

export interface NotifyOptions {
  description?: string;
}

interface ToastPayload {
  duration: number;
  description?: string;
  style: CSSProperties;
}

function buildPayload(duration: number, options?: NotifyOptions): ToastPayload {
  const payload: ToastPayload = {
    duration,
    style: { '--toast-duration': `${String(duration)}ms` } as CSSProperties,
  };
  if (options?.description !== undefined) {
    payload.description = options.description;
  }
  return payload;
}

export function notifyCreated(message: string, options?: NotifyOptions): void {
  toast.success(message, buildPayload(TOAST_CONFIRM_DURATION_MS, options));
}

export function notifyUpdated(message: string, options?: NotifyOptions): void {
  toast.warning(message, buildPayload(TOAST_CONFIRM_DURATION_MS, options));
}

export function notifyDeleted(message: string, options?: NotifyOptions): void {
  toast.error(message, buildPayload(TOAST_CONFIRM_DURATION_MS, options));
}

export function notifyError(message: string, options?: NotifyOptions): void {
  toast.error(message, buildPayload(TOAST_ERROR_DURATION_MS, options));
}
